import Button from 'react-bootstrap/Button'
import { CartContext } from '../../Context/CartContext'
import { useContext, memo } from 'react'
import { useProducts } from '../../Context/ProductContext'

const CartProduct = memo(function CartProduct(props) {
  const cart = useContext(CartContext)
  const { getProductData, isLoading } = useProducts()
  const id = props.id
  const quantity = props.quantity
  const productData = getProductData(id)

  if (isLoading) {
    return (
      <div className="cartModal">
        <p>Loading product...</p>
        <hr></hr>
      </div>
    )
  }

  if (!productData) {
    return (
      <div className="cartModal">
        <p>Product not found</p>
        <hr></hr>
      </div>
    )
  }

  let price = null
  if (productData.specialPrice && productData.specialPrice.$numberDecimal) {
    price = productData.specialPrice.$numberDecimal
  } else if (productData.price && productData.price.$numberDecimal) {
    price = productData.price.$numberDecimal
  } else if (productData.price) {
    price = productData.price
  }

  let priceValue = parseFloat(price) || 0

  return (
    <div className="cartModal">
      <h4>{productData.name}</h4>
      <h6>
        {quantity} x £{priceValue.toFixed(2)}
      </h6>
      <h6>Total: £ {(quantity * priceValue).toFixed(2)}</h6>
      <Button onClick={() => cart.addOneToCart(id, priceValue)} className="cartItemsValueButton">
        +
      </Button>
      <b>{quantity}</b>
      <Button onClick={() => cart.removeOneFromCart(id)} className="cartItemsValueButton">
        -
      </Button>
      <Button onClick={() => cart.deleteFromCart(id)} className="cartItemsRemoveButton">
        Remove
      </Button>
      <hr></hr>
    </div>
  )
})

export default CartProduct
